import { gql } from '@apollo/client';

export const IP_ADDRESS_INFO = gql`
  query IpAddressInfo {
    ipAddressInfo {
      countryPhonePrefix
    }
  }
`;
